import { useWatch } from 'react-hook-form';
import { useOrderSaleOrderSaleReceiptTypeInputQuery } from '../../../../../../../services';
import { IOrderSale } from '../order-sale-form';

// A receipt type that does not apply tax cannot carry a complemento or a nota de
// crédito, so the paperwork fields that depend on it are turned off. Until a
// receipt is picked we treat it as taxable so nothing is disabled prematurely.
export function useReceiptAppliesTax(): boolean {
    const receiptTypeId = useWatch({
        name: 'receipt_type_id',
    }) as IOrderSale['receipt_type_id'];
    const { data } = useOrderSaleOrderSaleReceiptTypeInputQuery();

    const receiptType = (data?.getReceiptTypes ?? []).find(
        (type) => type.id === receiptTypeId,
    );
    return receiptType ? receiptType.applies_tax : true;
}
